/**
 * Layout da folha do Pedido de Venda (§11.1). O Orçamento tem modelo único e não usa este enum.
 * Espelha LayoutImpressaoVendaEnum (API Vendas e OrquestradorVendas); trafega como número no
 * RegistrarImpressaoVendaRequest e compõe o texto da ocorrência de impressão.
 */
export enum LayoutImpressaoVendaEnum {
    Padrao = 1,
    Detalhado = 2,
    Recibo = 3,
}
